import React from 'react'
import PropTypes from 'prop-types'
import kebabCase from 'lodash.kebabcase'
import { Button, Tooltip, withStyles } from '@material-ui/core'
import { getLang } from '../../app/selectors/lang'
import { getRegionFromLocationId, getSingularRegion } from '../../app/selectors'
import { DownloadIcon } from '../../../icons'
import { getStateAbbr } from '../../../../shared/utils/states'
import { getLocationNameString } from '../selectors'

const styles = theme => ({
  root: {
    width: '100%',
    display: 'flex'
  },

})

/**
 * Button that downloads a report for the active location when pressed
 */
const DownloadReportButton = ({ location, classes, ...props }) => {
  const region = location && getRegionFromLocationId(location.id)
  const state = location && getStateAbbr(location.id)
  const isNotSchool = region === 'districts' || region === 'states'
  const hasData = location?.all_avg !== null && location?.all_avg !== undefined && location?.all_avg !== -999
  const hasDownload = isNotSchool && hasData
  const url = location && `${process.env.REACT_APP_PDF_ENDPOINT}${state}/report_${state}_${location.id}_${kebabCase(location.name)}.pdf`

  const onClick = () => {
    //fire analytics events
    window.dataLayer.push({
      event: 'reportDownloaded',
      geoTypeSelection: region,
      locationId: location.id,
      locationName: getLocationNameString(location)
    })
  }

  return (
    <Tooltip
      title={!isNotSchool
        ? getLang('LOCATION_REPORT_BUTTON_DISABLED_SCHOOL')
        : !hasData
          ? getLang('LOCATION_REPORT_BUTTON_DISABLED_DATA', { region: getSingularRegion(region) })
          : ''
      }
      placement="top"
      arrow
    >
      <div
        className={classes.root}
      >
        <Button
          href={url}
          target="_blank"
          disabled={!hasDownload}
          onClick={onClick}
          {...props}>
          <DownloadIcon />
          {getLang('LOCATION_REPORT_BUTTON')}
        </Button>
      </div>
    </Tooltip>
  )
}

DownloadReportButton.propTypes = {
  /** Location data object */
  location: PropTypes.object
}

export default withStyles(styles)(DownloadReportButton)